.root {
  align-items: center;
  background: color-mix(
    in srgb,
    var(--color-success, #22c55e) 8%,
    var(--color-background, #fff)
  );
  border: 1px solid color-mix(
      in srgb,
      var(--color-success, #22c55e) 32%,
      transparent
    );
  border-left: 3px solid var(--color-success, #22c55e);
  border-radius: 8px;
  color: var(--color-foreground, #18181b);
  display: flex;
  font-size: 13px;
  gap: 8px;
  padding: 8px 12px;
}

.icon {
  color: var(--color-success, #22c55e);
  flex-shrink: 0;
}

// Future page-action kinds can override the accent here. Default green
// (apply_filters) reads as "applied + healthy"; switch to a neutral
// blue or amber for kinds that aren't applied state.
.root-kind-apply_filters {
  // Inherits the default — apply_filters is the canonical "applied" look.
}
